export default "__VITE_ASSET__BGKh3Pkn__"